export default __webpack_public_path__ + "assets/rwanda-flag.png";